"use client";

import Footer from "@/components/home/home/footer";
import MobileNavbar from '@/components/common/MobileNavbar';
import Navbar from '@/components/common/Navbar';
import React, { useState } from "react";

const Support = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic will be handled later
    console.log("Form submitted:", formData);
  };

  return (
    <>
      {/* Top Nav */}
      <Navbar />
      {/* End Top Nav */}

      {/* Mobile Nav  */}
      <MobileNavbar />
      {/* End Mobile Nav  */}

      {/* Support Section */}
      <section className="pt60 pb60" style={{ minHeight: "80vh" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-8">
              {/* Header */}
              <div className="text-center mb-5">
                <h1 className="mb-3" style={{ fontSize: "2.5rem", fontWeight: "700" }}>
                  Get Support
                </h1>
                <p className="text-muted" style={{ fontSize: "1.1rem" }}>
                  We&apos;re here to help! Fill out the form below and we&apos;ll get back to you as soon as possible.
                </p>
              </div>

              {/* Support Form */}
              <div className="card shadow-sm border-0" style={{ borderRadius: "16px", overflow: "hidden" }}>
                <div className="card-body p-4 p-lg-5">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-4">
                      {/* Name Field */}
                      <div className="col-md-6">
                        <label htmlFor="name" className="form-label fw-semibold mb-2">
                          Full Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          id="name"
                          name="name"
                          placeholder="Enter your full name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          style={{
                            borderRadius: "8px",
                            border: "1px solid #e0e0e0",
                            padding: "12px 16px",
                          }}
                        />
                      </div>

                      {/* Email Field */}
                      <div className="col-md-6">
                        <label htmlFor="email" className="form-label fw-semibold mb-2">
                          Email Address <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control form-control-lg"
                          id="email"
                          name="email"
                          placeholder="your.email@example.com"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          style={{
                            borderRadius: "8px",
                            border: "1px solid #e0e0e0",
                            padding: "12px 16px",
                          }}
                        />
                      </div>

                      {/* Subject Field */}
                      <div className="col-12">
                        <label htmlFor="subject" className="form-label fw-semibold mb-2">
                          Subject <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          id="subject"
                          name="subject"
                          placeholder="What is your request about?"
                          value={formData.subject}
                          onChange={handleChange}
                          required
                          style={{
                            borderRadius: "8px",
                            border: "1px solid #e0e0e0",
                            padding: "12px 16px",
                          }}
                        />
                      </div>

                      {/* Message Field */}
                      <div className="col-12">
                        <label htmlFor="message" className="form-label fw-semibold mb-2">
                          Message <span className="text-danger">*</span>
                        </label>
                        <textarea
                          className="form-control form-control-lg"
                          id="message"
                          name="message"
                          rows="6"
                          placeholder="Please provide details about your request or issue..."
                          value={formData.message}
                          onChange={handleChange}
                          required
                          style={{
                            borderRadius: "8px",
                            border: "1px solid #e0e0e0",
                            padding: "12px 16px",
                            resize: "vertical",
                          }}
                        />
                      </div>

                      {/* Submit Button */}
                      <div className="col-12">
                        <button
                          type="submit"
                          className="btn btn-primary btn-lg w-100"
                          style={{
                            borderRadius: "8px",
                            padding: "14px 32px",
                            fontWeight: "600",
                            fontSize: "1rem",
                            backgroundColor: "#425363",
                            border: "none",
                            transition: "all 0.3s ease",
                            color: "#fff",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#34495e";
                            e.target.style.transform = "translateY(-2px)";
                            e.target.style.boxShadow = "0 4px 12px rgba(66, 83, 99, 0.3)";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "#425363";
                            e.target.style.transform = "translateY(0)";
                            e.target.style.boxShadow = "none";
                          }}
                        >
                          Submit Request
                          <i className="fal fa-arrow-right-long ms-2" />
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              {/* Additional Support Information */}
              <div className="row g-4 mt-4">
                <div className="col-md-4">
                  <div className="text-center p-4" style={{ borderRadius: "12px", backgroundColor: "#f8f9fa" }}>
                    <i className="fal fa-envelope fz40 mb-3" style={{ color: "#425363" }} />
                    <h5 className="mb-2">Email Us</h5>
                    <p className="text-muted mb-0 small">
                      <a href="mailto:support@olmo.homes" className="text-decoration-none">
                        support@olmo.homes
                      </a>
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="text-center p-4" style={{ borderRadius: "12px", backgroundColor: "#f8f9fa" }}>
                    <i className="fal fa-phone fz40 mb-3" style={{ color: "#425363" }} />
                    <h5 className="mb-2">Call Us</h5>
                    <p className="text-muted mb-0 small">02-9132934</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="text-center p-4" style={{ borderRadius: "12px", backgroundColor: "#f8f9fa" }}>
                    <i className="fal fa-clock fz40 mb-3" style={{ color: "#425363" }} />
                    <h5 className="mb-2">Response Time</h5>
                    <p className="text-muted mb-0 small">Within 24 hours</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <section className="footer-style1 pt60 pb-0">
        <Footer />
      </section>
    </>
  );
};

export default Support;

